import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import {
  Breadcrumb,
  Button,
  Modal,
  Tag,
  Space,
  Select,
  Spin,
  Menu,
  Dropdown, message,
} from "antd";
import { Link } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import {
  DashboardOutlined,
  PlusSquareOutlined,
  EyeOutlined,
  DownloadOutlined,
  UploadOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { MdOutlineLibraryBooks } from "react-icons/md";
import { NAIRA } from "../../defaults/utilities";
import DataTable from "../../components/common/table";
import { formatCurrency } from "../../helpers/currency";
import CreateBudgetComponent from "../../components/dashboard/createBudgetComponent";
import PreviewBudget from "../../components/dashboard/previewBudgetItem";
import { DUMMY_FINANCIAL_YEAR_DATA } from "./year";
import Header from "../../components/dashboard/header";
import {
  useDownloadBudgetReport, useDownloadProjectionReport,
  useGetBudgets, useGetProjections,
} from "../../hooks/budget/budgetQuery";
import RefreshContext from "../../context/refreshContext";
import { scrollToTop } from "../../helpers/dom";
import { useFetchAllYears } from "../../hooks/financialYear/financialYearQuery";
import { userStore } from "../../store/userStore";
import { useDepartments } from "../../hooks/department/departmentQuery";
import UploadRecord from "../../components/budgets/uploadRecords";
import BudgetReports from "../../components/budgets/budgetReport";
import ProjectionReports from "../../components/budgets/projectionReport";
import CreateProjectionComponent from "../../components/budgets/createProjectionComponent";
import PreviewProjection from "../../components/budgets/previewProjectionItem";
import UploadProjections from "../../components/budgets/uploadProjections";

const NoDataComponent = () => {
  return <h2>No data, Please Select Year</h2>;
};

const InflowOutflowUpdate = ({ item }) => {
  const [amount, setAmount] = useState(null)
  const [date, setDate] = useState(null)

  return (
    <>

    </>
  )
}

function PreviewItem({ budgetItem, updateItem }) {
  const [previewShow, setPreviewShow] = useState(false);
  const closeModal = () => setPreviewShow(false);
  const openModal = () => setPreviewShow(true);

  return (
    <>
      <Space>
        <Button type="primary" onClick={openModal}>
          <EyeOutlined />
          View
        </Button>
        <Button type="primary" style={{ background: 'green' }} onClick={() => message.info("Implementation in progress")}>
          <EyeOutlined />
          Stats
        </Button>
      </Space>
      <Modal
        centered
        open={previewShow}
        title={"Projection Details"}
        width={"80vw"}
        onCancel={closeModal}
        footer={null}
      >
        <PreviewProjection
          item={budgetItem}
          updateItem={updateItem}
          handleModalClose={closeModal}
        />
      </Modal>
    </>
  );
}

export default function StaffProjection() {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState(1);
  const [year, setYear] = useState(null);
  const [tempData, setTempData] = useState([]);
  const [fileUpload, setFileUpload] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [reporting, setReporting] = useState(false);

  const user = userStore((state) => state.user);

  const { years } = useFetchAllYears();

  const { flag, setFlag } = useContext(RefreshContext);
  const getProjections = useGetProjections();
  const { departments } = useDepartments();
  const downloadBudgetReport = useDownloadProjectionReport();

  const updateItem = (i) => {
    setData(
      data.map((d) => {
        if (d.id == i.id) {
          d = i;
        }
        return d;
      }),
    );
  };

  const PROJECTION_DATA_COLUMNS = [
    {
      title: "S/N",
      key: "s/n",
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "item",
    },
    {
      title: "Estimate",
      dataIndex: 'staffProjectionItems',
      key: 'staffProjectionItems',
      render: (_, { staffProjectionItems }) => staffProjectionItems.map(e => e.totalEstimate).reduce((a, b) => a + b, 0)
    },
    {
      title: "Office",
      dataIndex: "office",
      key: "office",
      render: (_, { office }) => office?.title ?? "None",
    },
    {
      title: "Final Approval",
      dataIndex: "finalApproved",
      key: "final",
      render: (_, { finalApproved }) => {
        const isApproved = <Tag color="green">Approved</Tag>;

        const notApproved = <Tag color="volcano">Not Approved</Tag>;

        return finalApproved ? isApproved : notApproved;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, item) => (
        <>
          <Space>
            {/*<Button>Hello</Button>*/}
            <PreviewItem budgetItem={item} updateItem={updateItem} />
          </Space>
        </>
      ),
    },
  ];

  useEffect(() => {
    scrollToTop();
  }, []);

  const handleStatusSearch = async (value) => {
    if (year) {
      setLoading(true);
      const response = await getProjections(year, value);
      setLoading(false);
      setData(response.content ?? []);
      setTempData(response.content);
    }
    setStatus(value);
  };

  const handleYearSearch = async (value) => {
    setYear(value);
    setLoading(true);
    const response = await getProjections(value, status);
    setLoading(false);
    setData(response.content ?? []);
    setTempData(response.content);
  };

  const downloadReport = async () => {
    if (year) {
      setDownloading(true);
      const d = await downloadBudgetReport(null, year);
      setDownloading(false);
    }
  };

  const showCreateModal = () => setIsOpen(true);
  const hideCreateModal = () => setIsOpen(false);
  const toggleUploadModal = () => setFileUpload(!fileUpload);
  return (
    <>
      <div className="main-container">
        <Header />
        <div className="main-body">
          <div className="info-bar">
            <Breadcrumb>
              <Breadcrumb.Item>
                <DashboardOutlined className="dashboard-icon" />
                <Link to={"/dashboard"}>Dashboard</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <AiOutlineFundProjectionScreen />
                <Link to="/dashboard/budgets">Staff Projection</Link>
              </Breadcrumb.Item>
            </Breadcrumb>
            <div>
              <Select
                showArrow
                placeholder="Status"
                onChange={handleStatusSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{
                  width: 120,
                }}
                options={[
                  {
                    value: 1,
                    label: "All",
                  },
                  {
                    value: 2,
                    label: "Approved",
                  },
                  {
                    value: 3,
                    label: "Unapproved",
                  },
                ]}
              />
            </div>
            <div>
              <Select
                showSearch
                placeholder="Year"
                onChange={handleYearSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                style={{
                  width: 150,
                }}
                options={[
                  ...years.map((year) => ({
                    value: year.id,
                    label: year.value,
                  })),
                ]}
              />
            </div>
            {user?.roles?.includes("CREATE_BUDGET") && !reporting && (
              <>
                <div>
                  <Button
                    style={{ backgroundColor: "green", color: "#FFFFFF" }}
                    onClick={showCreateModal}
                  >
                    <PlusSquareOutlined />
                    Create
                  </Button>
                </div>
                <div>
                  <Button
                    disabled={!year}
                    style={{ backgroundColor: "green", color: "#FFFFFF" }}
                    onClick={toggleUploadModal}
                  >
                    <UploadOutlined />
                    Upload
                  </Button>
                </div>
              </>
            )}
            <div>
              {/*<Button*/}
              {/*  disabled={!year}*/}
              {/*  onClick={() => setReporting(!reporting)}*/}
              {/*  style={{*/}
              {/*    backgroundColor: reporting ? "red" : "green",*/}
              {/*    color: "#FFFFFF",*/}
              {/*  }}*/}
              {/*>*/}
              {/*  {reporting ? "Back" : "Reporting"}*/}
              {/*</Button>*/}
              <Button onClick={downloadReport} loading={downloading} disabled={!year} style={{ backgroundColor: "green", color: "#FFFFFF" }} >
                <DownloadOutlined />
                Report
              </Button>
            </div>
          </div>

          <div className="table-section">
            <Spin spinning={loading}>
              {!reporting ? (
                <DataTable
                  cols={PROJECTION_DATA_COLUMNS}
                  data={data}
                  locale={{
                    emptyText: <NoDataComponent />,
                  }}
                />
              ) : (
                <ProjectionReports year={year} status={status} />
              )}
            </Spin>
          </div>
        </div>
      </div>
      <Modal
        centered
        title="Create a new Budget"
        open={isOpen}
        footer={null}
        onCancel={hideCreateModal}
        width={"75vw"}
      >
        <CreateProjectionComponent projection={null} toggleOpen={() => setIsOpen(false)} />
      </Modal>
      <Modal
        centered
        title="Upload budgets"
        open={fileUpload}
        footer={null}
        onCancel={toggleUploadModal}
        width={"50vw"}
      >
        <UploadProjections onUpload={toggleUploadModal} />
      </Modal>
    </>
  );
}
